'use client';

import { Sheet, SheetContent, SheetTitle } from '@ahafood/ui/components/sheet';
import { useCallback, useEffect, useState } from 'react';
import OrderNotifications from './page';
import { useIsMobile } from '@/lib/is-mobile';

interface OrderListSheetProps {
  orderId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export default function OrderListSheet({
  orderId,
  isOpen,
  onClose,
}: OrderListSheetProps) {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleOpenChange = useCallback(
    (value: boolean) => {
      if (!value) {
        const isInTransition =
          document.documentElement.dataset.drawerToSheetTransition === 'true';
        if (!isInTransition) {
          onClose();
        }
      }
      setOpen(value);
    },
    [onClose]
  );

  if (!isOpen && !orderId) return null;

  // Mobile Sheet version
  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent
        className="size-full md:w-[450px] max-w-lg mx-auto pt-0 px-0 bg-white flex flex-col ios-webview-fix overflow-y-auto z-50"
        side={isMobile ? 'bottom' : 'right'}
        style={{ WebkitOverflowScrolling: 'touch' }}
        onClick={(e) => e.stopPropagation()}
      >
        <SheetTitle className="text-xl font-semibold hidden">
          Chi tiết đơn hàng
        </SheetTitle>
        <OrderNotifications orderId={orderId} onClose={onClose} />
      </SheetContent>
    </Sheet>
  );
}
